import type { JSX } from 'react'

export const ChromecastIcon = (): JSX.Element => (
  <use href='#chromecastIcon' height='100%' width='100%' />
)
